export const SHAREABLE_DOCUMENT_TYPES = ['Decision', 'Unit'];
export const MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024; // 1GB in bytes
export const MAX_FILE_SIZE_PREVIEW = 40 * 1024 * 1024; // 40MB — files above this won't have thumbnails generated

export default SHAREABLE_DOCUMENT_TYPES;
